import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { parseLinkNode } from "../../../utils/links";
import { LINK_TARGETS } from "../../../utils/constants/linkTargets";

const LinkWrapper = ({
    currentLanguageCode,
    linkNode,
    linkClass,
    linkStyle,
    children,
    renderChildren = false,
    fallbackWrapperEl: FallbackWrapperEl = null,
}) => {
    const link = parseLinkNode(linkNode, currentLanguageCode);

    if (!link.hasLink) {
        if (!renderChildren) return null;

        return FallbackWrapperEl ? <FallbackWrapperEl className={linkClass}>{children}</FallbackWrapperEl> : children;
    }

    switch (link.type) {
        case LINK_TARGETS.EXTERNAL:
        case LINK_TARGETS.BLOG:
        case LINK_TARGETS.EVENTS:
        case LINK_TARGETS.B2B_PROFILES:
            return (
                <a href={link.value} className={linkClass} style={linkStyle} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            );

        case LINK_TARGETS.WEBSITE:
        case LINK_TARGETS.ARTIFICIAL:
        case LINK_TARGETS.ECOMMERCE_CATEGORIES:
        case LINK_TARGETS.ECOMMERCE_PRODUCTS:
            return (
                <Link to={link.value} className={linkClass} style={linkStyle}>
                    {children}
                </Link>
            );
    }
};

export default connect()(multilanguage(LinkWrapper));
